<template>
  <head>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
    />
  </head>

  <div class="root">
    <div class="navigation">
      <div class="navigation-container-1">
        <div class="navigation-header">
          <h1>CS Portfolio</h1>
        </div>

        <div class="navigation-item navigation-item-active">
          <p>Home</p>
        </div>
        <div class="navigation-item">
          <p>My Properties</p>
        </div>
        <div class="navigation-item">
          <p>New Property</p>
        </div>
        <div class="navigation-item">
          <p>Transfer</p>
        </div>
      </div>

      <div class="navigation-container-2">
        <div class="navigation-item2">
          <p>CS Enforcer</p>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="page-content-header">
        <div class="page-content-title">
          <h1><i class="fa-solid fa-hotel"></i> My Properties</h1>
        </div>

        <div class="page-content-search">
          <input placeholder="search" />
        </div>
      </div>

      <div class="property-container">
        <div class="property-card">
          <div class="property-card-header">
            <p>Crofton House Condominiums</p>
          </div>
          <div class="property-card-body">
            <div class="property-card-body-item">
              <p>Address:</p>
              <p>123 Fake St</p>
            </div>
            <div class="property-card-body-item">
              <p>Corporation #:</p>
              <p>123-1234</p>
            </div>
            <div class="property-card-body-item">
              <p>Units:</p>
              <p>100</p>
            </div>
            <div class="property-card-body-item">
              <p>Type:</p>
              <p>Apartment Style</p>
            </div>
            <div class="property-card-body-item">
              <button class="property-card-body-btn">View Property</button>
            </div>
          </div>
        </div>

        <div class="property-card">
          <div class="property-card-header">
            <p>Crofton House Condominiums</p>
          </div>
          <div class="property-card-body">
            <div class="property-card-body-item">
              <p>Address:</p>
              <p>123 Fake St</p>
            </div>
            <div class="property-card-body-item">
              <p>Corporation #:</p>
              <p>123-1234</p>
            </div>
            <div class="property-card-body-item">
              <p>Units:</p>
              <p>100</p>
            </div>
            <div class="property-card-body-item">
              <p>Type:</p>
              <p>Apartment Style</p>
            </div>
            <div class="property-card-body-item">
              <button class="property-card-body-btn">View Property</button>
            </div>
          </div>
        </div>

        <div class="property-card">
          <div class="property-card-header">
            <p>Crofton House Condominiums</p>
          </div>
          <div class="property-card-body">
            <div class="property-card-body-item">
              <p>Address:</p>
              <p>123 Fake St</p>
            </div>
            <div class="property-card-body-item">
              <p>Corporation #:</p>
              <p>123-1234</p>
            </div>
            <div class="property-card-body-item">
              <p>Units:</p>
              <p>100</p>
            </div>
            <div class="property-card-body-item">
              <p>Type:</p>
              <p>Apartment Style</p>
            </div>
            <div class="property-card-body-item">
              <button class="property-card-body-btn">View Property</button>
            </div>
          </div>
        </div>

        <div class="property-card">
          <div class="property-card-header">
            <p>Crofton House Condominiums</p>
          </div>
          <div class="property-card-body">
            <div class="property-card-body-item">
              <p>Address:</p>
              <p>123 Fake St</p>
            </div>
            <div class="property-card-body-item">
              <p>Corporation #:</p>
              <p>123-1234</p>
            </div>
            <div class="property-card-body-item">
              <p>Units:</p>
              <p>100</p>
            </div>
            <div class="property-card-body-item">
              <p>Type:</p>
              <p>Apartment Style</p>
            </div>
            <div class="property-card-body-item">
              <button class="property-card-body-btn">View Property</button>
            </div>
          </div>
        </div>

        <div class="property-card">
          <div class="property-card-header">
            <p>Crofton House Condominiums</p>
          </div>
          <div class="property-card-body">
            <div class="property-card-body-item">
              <p>Address:</p>
              <p>123 Fake St</p>
            </div>
            <div class="property-card-body-item">
              <p>Corporation #:</p>
              <p>123-1234</p>
            </div>
            <div class="property-card-body-item">
              <p>Units:</p>
              <p>100</p>
            </div>
            <div class="property-card-body-item">
              <p>Type:</p>
              <p>Apartment Style</p>
            </div>
            <div class="property-card-body-item">
              <button class="property-card-body-btn">View Property</button>
            </div>
          </div>
        </div>

        <div class="property-card-add">
          <i class="fa-solid fa-plus"></i>
          <p class="property-card-add-text">Add New Property</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script></script>

<style scoped>
.root {
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.navigation {
  margin: 1rem;
  background: white;
  height: 95%;
  width: 16rem;
  border-radius: 0.5rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
}

.navigation-item {
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-bottom: 1px solid black;
}

.navigation-item-active {
  background: rgb(192, 192, 192);
}

.navigation-item2 {
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-top: 1px solid black;
}

.navigation-header {
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-bottom: 2px solid black;
}

.page-content {
  padding: 0rem;
  height: 95%;
  width: 82%;
}

.property-card {
  background: white;
  border-radius: 0.25rem;
  width: 23.5rem;
  color: black;
  box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  margin-bottom: 1rem;
}

.property-card-add {
  background: white;
  border-radius: 0.25rem;
  width: 23.5rem;
  color: var(--csm-blue);
  box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  margin-bottom: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 5rem;
  position: relative;
}

.property-card-add:hover {
  transform: scale(1.05);
  cursor: pointer;
  background: var(--csm-blue);
  color: white;
}

.property-card-add-text {
  font-size: 1rem;
  color: black;
  position: absolute;
  bottom: 25px;
}

.property-card-header {
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1.1rem;
  background: var(--csm-blue);
  color: white;
  border-radius: 0.25rem 0.25rem 0rem 0rem;
}

.property-card-body {
  padding: 1rem;
}

.property-card-body-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.page-content-header {
  background: white;
  color: black;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.25rem;
  padding: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-left: 2rem;

  box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 4px 21px -4px rgba(0, 0, 0, 0.5);
}

.property-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.property-card-body-btn {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  background: var(--csm-blue);
  color: white;
  margin-top: 1rem;
}

.property-card-body-btn:hover {
  cursor: pointer;
}
</style>
